module.exports = __webpack_public_path__ + "static/media/ice27.94b7c7e8.webp";